/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: find out any for new consumer search data
import { each } from 'lodash'
import { SearchFiltersRefinement } from 'search'
import { getActiveFilterTypes } from './formatAlgoliaFilters'
import { isAccessoriesPresent, isClothingPresent } from './isCategoryPresent'

type SearchFilters = {
  [key: string]: string[]
}

interface IOverrides {
  hideBrand: boolean
}

const defaultOverrides = {
  hideBrand: false,
}

export const consumerSearchHideFilters = (overrides: any) => {
  const result: Set<string> = new Set()

  if (overrides.category) {
    result.add(SearchFiltersRefinement.Condition)
  } else {
    result.add(SearchFiltersRefinement.PresentationSizes)
  }

  if (overrides.brand) {
    result.add(SearchFiltersRefinement.Brand)
  }

  if (overrides.silhouette) {
    result.add(SearchFiltersRefinement.Silhouette)
    result.add(SearchFiltersRefinement.Brand)
  }

  if (overrides.gender) {
    if (overrides.gender[0] === 'men') {
      result.add(SearchFiltersRefinement.WomenSizes)
      result.add(SearchFiltersRefinement.YouthSizes)
    }
    if (overrides.gender[0] === 'youth') {
      result.add(SearchFiltersRefinement.WomenSizes)
      result.add(SearchFiltersRefinement.MenSizes)
    }
    if (overrides.gender[0] === 'women') {
      result.add(SearchFiltersRefinement.YouthSizes)
      result.add(SearchFiltersRefinement.MenSizes)
    }
  }

  return result
}

const hideFilters = (
  filters?: Partial<SearchFilters>,
  overrides: IOverrides = defaultOverrides,
): Set<string> => {
  const result: Set<string> = new Set()
  if (!filters) {
    return result
  }
  const activeFilterTypes = getActiveFilterTypes(filters)
  each(activeFilterTypes, (filterType) => {
    if (filterType === SearchFiltersRefinement.Condition) {
      result.add(SearchFiltersRefinement.Condition)
    }
    if (filterType === SearchFiltersRefinement.Brand) {
      result.add(SearchFiltersRefinement.Brand)
    }
    if (filterType === SearchFiltersRefinement.Silhouette && filters[filterType]?.length === 1) {
      result.add(filterType)
      result.add(SearchFiltersRefinement.Brand)
    }
    if (overrides.hideBrand) {
      result.add(SearchFiltersRefinement.Brand)
    }
    if (filterType === 'single_gender') {
      if (filters.single_gender?.[0] === 'men') {
        result.add(SearchFiltersRefinement.WomenSizes)
        result.add(SearchFiltersRefinement.YouthSizes)
      }
      if (filters.single_gender?.[0] === 'youth') {
        result.add(SearchFiltersRefinement.WomenSizes)
        result.add(SearchFiltersRefinement.MenSizes)
      }
      if (filters.single_gender?.[0] === 'women') {
        result.add(SearchFiltersRefinement.YouthSizes)
        result.add(SearchFiltersRefinement.MenSizes)
      }
    }
  })
  if (
    isClothingPresent(filters.product_category) ||
    isAccessoriesPresent(filters.product_category)
  ) {
    result.add(SearchFiltersRefinement.Condition)
  } else {
    result.add(SearchFiltersRefinement.PresentationSizes)
  }
  return result
}

export default hideFilters
